import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FC } from "react";
// Entire free icon packs
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";

// Add to library
library.add(fas, far, fab);

export const Icons: FC<FontAwesomeIconProps> = (props) => {
  return <FontAwesomeIcon {...props} />;
};
